import { Flex, IllustratedMessage } from '@eleveo/components-react';
import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

export const AccessForbidden: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t('applications.ETLManagement')}</title>
      </Helmet>
      <Flex alignItems="center" justifyContent="center" className="w-full h-full">
        <IllustratedMessage heading={t('accessForbidden.title')} description={t('accessForbidden.description')} />
      </Flex>
    </>
  );
};
